export default __webpack_public_path__ + "static/media/neet_score_bg.1d7bfaf8.webp";